export default __webpack_public_path__ + "images/partly-cloudy-day.png";